import '@/styles/globals.css'
import 'lenis/dist/lenis.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Archivo, Instrument_Serif, Manrope } from 'next/font/google'
import { MotionConfig } from 'motion/react'
import { SmoothScroll } from '@/components/generals/smooth-scroll'
import { ToneController } from '@/components/generals/tone-controller'

// Body copy keeps Manrope from the original JAP site.
const sans = Manrope({
    subsets: ['latin']
})

// Display face with a width axis, used for the scroll-driven typography.
const heading = Archivo({
    subsets: ['latin'],
    axes: ['wdth']
})

// Editorial accent face for quotes, notes and italics.
const serif = Instrument_Serif({
    subsets: ['latin'],
    weight: '400',
    style: ['normal', 'italic']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:ui-monospace, SFMono-Regular, Menlo, monospace;--font-app-heading:${heading.style.fontFamily};--font-app-serif:${serif.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <MotionConfig reducedMotion='user'>
                <SmoothScroll>
                    <Component {...pageProps} />
                    <ToneController />
                </SmoothScroll>
            </MotionConfig>
        </div>
    )
}

export default App
